/**
 * Backend (cp-core) `enrichFileWithUrl` собирает абсолютный URL для file
 * payload'ов используя `APP_HOST` env (на проде = `https://cp.o.kg`). Этот
 * hostname — internal cp-core, недоступен external клиентам напрямую (только
 * через Gravitee proxy `https://ccp.o.kg/g/cp`).
 *
 * Виджет получает `file.url` как-есть и подставляет в `<img src>` / `<a href>`,
 * браузер пытается загрузить с `cp.o.kg` → CORS / unreachable / mixed content.
 *
 * Решение — переписать absolute URL на свой apiUrl: extract path+search+hash
 * и prepend'ом apiUrl. Idempotent: если URL уже на нашем proxy — не трогаем.
 *
 * Backend не модифицирован осознанно: тогда пришлось бы передеплоить cp-core
 * (1 час pipeline + risk). Виджет умеет это сам, без backend coupling'а.
 */
export function rewriteAbsoluteToProxy(
  rawUrl: string | undefined,
  apiUrl: string | undefined,
): string | undefined {
  if (!rawUrl || !apiUrl) return rawUrl;
  try {
    const incoming = new URL(rawUrl);
    const proxy = new URL(apiUrl);
    const proxyPath = proxy.pathname.replace(/\/+$/, '');

    // Same origin + path уже начинается с proxy-prefix → idempotent, no-op.
    if (incoming.origin === proxy.origin) {
      if (!proxyPath || incoming.pathname.startsWith(`${proxyPath}/`)) {
        return rawUrl;
      }
      // Same origin, но без prefix'а → дочиним
      return `${proxy.origin}${proxyPath}${incoming.pathname}${incoming.search}${incoming.hash}`;
    }

    // Different origin (например cp.o.kg vs ccp.o.kg) → перепишем целиком
    return `${proxy.origin}${proxyPath}${incoming.pathname}${incoming.search}${incoming.hash}`;
  } catch {
    // Невалидный URL (relative, пустой) → возвращаем как есть, пусть caller разбирается
    return rawUrl;
  }
}
